import http from "./http.service";

class FileService {
    constructor() {
        this.$http = http;
    }

    downloadFilePost(url, data) {
        return new Promise((resolve, reject) => {
            this.$http
                .post(url, data)
                .then(response => {
                    this.parseSuccessRequest(response.data);
                    resolve();
                })
                .catch(err => reject(err));
        });
    }

    parseSuccessRequest(result) {
        if (window.URL && window.Blob && window.atob) {
            // Do it the HTML5 compliant way
            var blob = this.base64ToBlob(result.data, result.mimetype);

            // we create an <a> element with a link to the blob
            // Created <a> element will be used for downloading the content from the Blob
            var a = document.createElement("a");

            // in IE 11 dows not have 'download' attr in a tag
            if ("download" in a) {
                var url = window.URL.createObjectURL(blob);

                document.body.appendChild(a);
                a.href = url;
                a.download = result.filename;
                a.click();

                // remove the <a> element from the DOM
                document.body.removeChild(a);
            } else {
                navigator.msSaveBlob(blob, result.filename);
            }
        }
    }

    /* Convert Base64 encoded string into a Blob
     * The byte array is sliced into smaller chunks with size 512 by default
     * but chunk size can be changed with parameter "slicesize"
     */
    base64ToBlob(base64, mimetype, slicesize) {
        if (!window.atob || !window.Uint8Array) {
            // The current browser doesn't have the atob function. Cannot continue
            return null;
        }
        mimetype = mimetype || "";
        slicesize = slicesize || 512;
        var bytechars = atob(base64); // decode base64
        var bytearrays = [];

        for (var offset = 0; offset < bytechars.length; offset += slicesize) {
            // slice the byte array
            var slice = bytechars.slice(offset, offset + slicesize);
            var bytenums = new Array(slice.length);
            // process the sliced chunk
            for (var i = 0; i < slice.length; i++) {
                bytenums[i] = slice.charCodeAt(i);
            }
            var bytearray = new Uint8Array(bytenums);
            bytearrays[bytearrays.length] = bytearray;
        }
        return new Blob(bytearrays, { type: mimetype });
    }
}

export default new FileService();
